import { render, staticRenderFns } from "./LoyaltySummaryChartCard.vue?vue&type=template&id=6115a3eb&scoped=true"
import script from "./LoyaltySummaryChartCard.vue?vue&type=script&lang=js"
export * from "./LoyaltySummaryChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115a3eb",
  null
  
)

export default component.exports